module.exports = require("core-js-pure/stable/parse-float");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/parse-float.js
// module id = 6386
// module chunks = 25